import { WaitlistEntry } from '@dreryk/egabinet-waitlist-frontend-api';

import { TIMES_OF_DAY } from '../form/fields/DayPreferenceField/DayPreferenceField.constants';
import { DAYS_OF_WEEK } from '../form/fields/AllDaysPreferencesField/AllDaysPreferencesField.constants';
import { defaultDayTimePreferencesInitialValues } from '../form/WaitlistForm.constants';

import { WaitlistEntryUpdateFormBean } from './WaitlistEntryUpdate.types';

export const getInitialValues = (waitlistEntry: WaitlistEntry): WaitlistEntryUpdateFormBean => {
   const patientAvailabilityTimesOfDay = Object.values(waitlistEntry.patientAvailability);
   const allTimesChosen = Object.values(waitlistEntry.patientAvailability).every(
      (timesOfDay) => TIMES_OF_DAY.length === timesOfDay.length
   );

   return {
      urgent: waitlistEntry.importance === 'IMPORTANT',
      note: waitlistEntry.note ?? null,
      patient: waitlistEntry.patient ?? null,
      location: waitlistEntry.location ?? undefined,
      practitioner: waitlistEntry.practitioner ?? undefined,
      videoConsultation: waitlistEntry.encounterMode === 'VIDEO_CONSULTATION',
      allDaysPreferences: DAYS_OF_WEEK.length === patientAvailabilityTimesOfDay.length && allTimesChosen,
      dayTimePreferences: {
         ...defaultDayTimePreferencesInitialValues,
         ...waitlistEntry.patientAvailability,
      },
      dayTimePreferencesValidation: false,
      reservationPreference: waitlistEntry.reservationPreference,
      service: waitlistEntry.receptionService ?? null,
   };
};
